export const partnerIdSearchParamName = 'partner_id';
